import { useRadioProviderContext as n, RadioScopedContextProvider as s } from "../__chunks/BGBYET7R.js";
import { useComposite as d } from "../__chunks/NSTBQJLB.js";
import { forwardRef as u, createHook as c, createElement as f } from "../__chunks/VOQWLFSQ.js";
import { useWrapElement as v } from "../__chunks/5GGHRIN3.js";
import { __objRest as R, __spreadValues as a } from "../__chunks/3YLGPPWQ.js";
import { invariant as l } from "../../../../../../@ariakit_core@0.4.15/node_modules/@ariakit/core/esm/__chunks/PBFD2E7P.js";
import { jsx as _ } from "react/jsx-runtime";
var x = "div", G = c(
  function(t) {
    var e = t, { store: r } = e, o = R(e, ["store"]);
    const p = n();
    return r = r || p, l(
      r,
      process.env.NODE_ENV !== "production" && "RadioGroup must receive a `store` prop or be wrapped in a RadioProvider component."
    ), o = v(
      o,
      (m) => /* @__PURE__ */ _(s, { value: r, children: m }),
      [r]
    ), o = a({
      role: "radiogroup"
    }, o), o = d(a({ store: r }, o)), o;
  }
), h = u(function(t) {
  const e = G(t);
  return f(x, e);
});
export {
  h as RadioGroup,
  G as useRadioGroup
};
//# sourceMappingURL=radio-group.js.map
